import { createContext, useContext, ReactNode, useState } from 'react';
import { Language, Translations } from './types';
import { en } from './translations/en';
import { zh } from './translations/zh';

interface I18nContextValue {
  language: Language;
  setLanguage: (lang: Language) => void;
  t: Translations;
}

const I18nContext = createContext<I18nContextValue | undefined>(undefined);

const translations = {
  en,
  zh,
};

interface I18nProviderProps {
  children: ReactNode;
  defaultLanguage?: Language;
}

export const I18nProvider = ({ children, defaultLanguage = 'en' }: I18nProviderProps) => {
  const [language, setLanguage] = useState<Language>(defaultLanguage);
  
  const value: I18nContextValue = {
    language,
    setLanguage,
    t: translations[language],
  };
  
  return (
    <I18nContext.Provider value={value}>
      {children}
    </I18nContext.Provider>
  );
};

export const useI18n = () => {
  const context = useContext(I18nContext);
  if (context === undefined) {
    throw new Error('useI18n must be used within an I18nProvider');
  }
  return context;
};

export const useTranslation = () => {
  const { t } = useI18n();
  return t;
};